import __var_0__ from '@stdlib/utils/define-read-only-property';
import __var_1__ from '@stdlib/stats/base/dists/betaprime/cdf';
import __var_2__ from '@stdlib/stats/base/dists/betaprime/ctor';
import __var_3__ from '@stdlib/stats/base/dists/betaprime/kurtosis';
import __var_4__ from '@stdlib/stats/base/dists/betaprime/logcdf';
import __var_5__ from '@stdlib/stats/base/dists/betaprime/logpdf';
import __var_6__ from '@stdlib/stats/base/dists/betaprime/mean';
import __var_7__ from '@stdlib/stats/base/dists/betaprime/mode';
import __var_8__ from '@stdlib/stats/base/dists/betaprime/pdf';
import __var_9__ from '@stdlib/stats/base/dists/betaprime/quantile';
import __var_10__ from '@stdlib/stats/base/dists/betaprime/skewness';
import __var_11__ from '@stdlib/stats/base/dists/betaprime/stdev';
import __var_12__ from '@stdlib/stats/base/dists/betaprime/variance';
/**

*
* Copyright (c) 2018 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

/*
* When adding modules to the namespace, ensure that they are added in alphabetical order according to module name.
*/

// MODULES //
var setReadOnly = __var_0__;


// MAIN //

/**
* Top-level namespace.
*
* @namespace betaprime
*/
var betaprime = {};

/**
* @name cdf
* @memberof betaprime
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/betaprime/cdf}
*/
setReadOnly( betaprime, 'cdf', __var_1__);

/**
* @name BetaPrime
* @memberof betaprime
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/betaprime/ctor}
*/
setReadOnly( betaprime, 'BetaPrime', __var_2__);

/**
* @name kurtosis
* @memberof betaprime
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/betaprime/kurtosis}
*/
setReadOnly( betaprime, 'kurtosis', __var_3__);

/**
* @name logcdf
* @memberof betaprime
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/betaprime/logcdf}
*/
setReadOnly( betaprime, 'logcdf', __var_4__);

/**
* @name logpdf
* @memberof betaprime
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/betaprime/logpdf}
*/
setReadOnly( betaprime, 'logpdf', __var_5__);

/**
* @name mean
* @memberof betaprime
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/betaprime/mean}
*/
setReadOnly( betaprime, 'mean', __var_6__);

/**
* @name mode
* @memberof betaprime
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/betaprime/mode}
*/
setReadOnly( betaprime, 'mode', __var_7__);

/**
* @name pdf
* @memberof betaprime
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/betaprime/pdf}
*/
setReadOnly( betaprime, 'pdf', __var_8__);

/**
* @name quantile
* @memberof betaprime
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/betaprime/quantile}
*/
setReadOnly( betaprime, 'quantile', __var_9__);

/**
* @name skewness
* @memberof betaprime
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/betaprime/skewness}
*/
setReadOnly( betaprime, 'skewness', __var_10__);

/**
* @name stdev
* @memberof betaprime
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/betaprime/stdev}
*/
setReadOnly( betaprime, 'stdev', __var_11__);

/**
* @name variance
* @memberof betaprime
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/betaprime/variance}
*/
setReadOnly( betaprime, 'variance', __var_12__);


// EXPORTS //
export default betaprime;

export { __var_1__ as cdf, __var_2__ as BetaPrime, __var_3__ as kurtosis, __var_4__ as logcdf, __var_5__ as logpdf, __var_6__ as mean, __var_7__ as mode, __var_8__ as pdf, __var_9__ as quantile, __var_10__ as skewness, __var_11__ as stdev, __var_12__ as variance};